<bn-web-ui-card
  class="mb-2"
  heading="DDoS protection"
  [isCollapsed]="!selectedShield()?.learningMode"
  [isCollapsible]="true"
  [isFullHeight]="true"
  [learnMore]="{ href: 'https://docs.bunny.net/docs/shield-ddos-mitigation', options: { rightValue: '60px', topValue: '25px' } }">
  <p class="bn-container--md">
    Bunny Shield is our DDoS mitigation system designed to detect, block, and stop malicious requests before they ever reach your origin.
  </p>
  <div class="row mt-4">
    <div class="col-12 col-xl-6">
      <fa-icon
        class="title-icon text-warning-6"
        icon="globe" />
      <div class="text-bunny-dark text-500-semi-bold mb-2">Network</div>
      <p class="pe-4 pe-xl-8">
        Network-level (Layer 3/4) DDoS mitigation provides robust coverage against UDP and TCP protocol attacks, including DNS, SNMP, and NTP amplification
        vectors, as well as ACK, SYN-ACK, and SYN floods, and more.
      </p>
    </div>
    <div class="col-12 col-xl-6 mt-4 mt-xl-0">
      <fa-icon
        class="title-icon text-warning-6"
        icon="browser" />
      <div class="text-bunny-dark text-500-semi-bold mb-2">Website</div>
      <p class="pe-4 pe-xl-8">
        Website-level (Layer 7) DDoS mitigation provides extensive coverage against HTTP floods, such as XML-RPC (WordPress Pingback), SSL exhaustion floods,
        GET/HEAD/POST floods, and more.
      </p>
    </div>
  </div>
</bn-web-ui-card>
<bn-web-ui-card
  class="mb-2"
  heading="DDoS configuration">
  <p>Tune your DDoS mitigation to match your website`s specific traffic requirements.</p>
  <div
    class="row"
    [formGroup]="ddosConfigForm">
    <!-- <div class="col-12 col-xl-6">
    <div class="pe-xl-5">
      <p class="bn-app-shield-ddos-page__ddos-config mb-4">Mitigation mode</p>
      <p class="mb-4">
        Logging will log all DDoS events for review while allowing traffic to pass through to your origin, whereas Blocking will drop requests at our edge.
      </p>
      <bn-web-ui-radio-tabs
        formControlName="dDoSExecutionMode"
        [isLoading]="isLoadingMode()"
        [items]="shieldExecutionModes | mapWafEnumToFormListItems">
      </bn-web-ui-radio-tabs>
    </div>
  </div> -->
    <div class="col-12 col-xl-6">
      <div class="pe-xl-5">
        <p class="bn-app-shield-ddos-page__ddos-config mb-4">Valid challenge window</p>
        <p class="mb-4">
          The duration a visitor can access your website after passing a challenge. Once the timeout expires, they will be required to complete a new challenge.
        </p>
        <bn-web-ui-select
          class="d-block mb-4"
          formControlName="dDoSChallengeWindow"
          id="shield-ddos-challenge-window-dropdown"
          size="sm"
          [isLoading]="isLoadingChallengeWindow()"
          [items]="dDoSChallengeWindowItems"
          [options]="{ placeholder: 'Valid Challenge Window' }" />
      </div>
    </div>
  </div>
  <div class="mt-3">
    <h2 class="mb-4">Sensitivity</h2>
  </div>
  <div class="sensitivity-picker mb-4">
    <app-app-shield-sensitivity-picker
      [isLoading]="isLoadingSensitivity()"
      [items]="levelTemplates"
      (itemClick)="onSelectDDoSSensitivity($event)" />
  </div>
</bn-web-ui-card>

<div class="my-2">
  <bn-web-ui-card heading="Threat activity">
    <div class="chart-container position-relative">
      <bn-chart-multi-metric
        [chartConfig]="{
          formatMode: 'metricSymbol',
          seriesColors: ['warning', 'danger', 'info', 'success'],
          summaryLabels: [
            { key: 'challengedRequests', label: 'Challenged', color: 'warning' },
            { key: 'blockedRequests', label: 'Blocked Sources', color: 'danger' },
            { key: 'loggedRequests', label: 'Logged', color: 'info' },
            { key: 'verifiedRequests', label: 'Verified', color: 'success' },
          ],
        }"
        [data]="threatActivityChart().chartSeries"
        [dataGranularity]="dataGranularity()"
        [summaryLabels]="threatActivityChart().total" />
      @if (!threatActivityChartHasData()) {
        <div class="chart-overlay">
          <span>There is no attack data to show yet.</span>
        </div>
      }
    </div>
  </bn-web-ui-card>
</div>

<bn-web-ui-documentation
  [linksFirst]="linksFirst"
  [titleFirst]="titleFirst" />
